import { PlusCircle } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";
import useAppStore from "common/hooks/useAppStore";

export default function CreateCampaign() {
  const { accounts_count: accountsCount, permissions } =
    useSelectedWorkspaceContext();

  const setIsCampaignModalOpen = useAppStore(
    (state) => state.setIsCampaignModalOpen,
  );

  const hasAccounts = accountsCount > 0;

  const buttonComponent = permissions.includes("campaigns_full") && (
    <Button
      data-intercom-target="create-campaign-button"
      onClick={() => setIsCampaignModalOpen(true)}
      disabled={!hasAccounts}
      leftIcon={<PlusCircle weight="fill" />}
    >
      Create campaign
    </Button>
  );

  if (hasAccounts) {
    return buttonComponent;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{buttonComponent}</TooltipTrigger>
      <TooltipContent>
        You must connect a LinkedIn account before creating a campaign
      </TooltipContent>
    </Tooltip>
  );
}
